const defaults = {
    cartModal: '.js-ajax-cart-modal', // classname
    cartModalContent: '.js-ajax-cart-modal-content', // classname
    cartModalClose: '.js-ajax-cart-modal-close', // classname
    cartDrawer: '.ajax-cart__drawer', // classname    
    cartDrawerContent: '.js-ajax-cart-drawer-content', // classname
    cartDrawerClose: '.closeicon,.ajax-cart-drawer__close', // classname
    cartDrawerTrigger: '.js-ajax-cart-drawer-trigger', // classname
    cartDrawerTrigger1: '.js-ajax-cart-drawer-trigger1', // classname
    cartOverlay: '.js-ajax-cart-overlay', // classname
    cartCounter: '.js-ajax-cart-counter', // classname
    addToCart: '.js-ajax-add-to-cart', // classname
    removeFromCart: '.js-ajax-remove-from-cart', //classname
    removeFromCartNoDot: 'js-ajax-remove-from-cart', //classname,
    checkoutButton: '.js-ajax-checkout-button',
};

const cartModal = document.querySelector(defaults.cartModal);
const cartModalContent = document.querySelector(defaults.cartModalContent);
const cartModalClose = document.querySelector(defaults.cartModalClose);
const cartDrawer = document.querySelector(defaults.cartDrawer);
const cartDrawerContent = document.querySelector(defaults.cartDrawerContent);
const cartDrawerClose = document.querySelector(defaults.cartDrawerClose);
const cartDrawerTrigger = document.querySelector(defaults.cartDrawerTrigger);
const cartDrawerTrigger1 = document.querySelector(defaults.cartDrawerTrigger1);
const cartOverlay = document.querySelector(defaults.cartOverlay);
const cartCounter = document.querySelector(defaults.cartCounter);
const addToCart = document.querySelectorAll(defaults.addToCart);
let removeFromCart = document.querySelectorAll(defaults.removeFromCart);
const checkoutButton = document.querySelector(defaults.checkoutButton);
const htmlSelector = document.documentElement;

for (let i = 0; i < addToCart.length; i++) {

    addToCart[i].addEventListener('click', function(event) {
        event.preventDefault();
        const formID = this.closest("form").getAttribute('id');//this.parentNode.getAttribute('id');   
      console.log(formID);
      //alert(formID);
        addProductToCart(formID);

    });

}

function addProductToCart(formID) {
    $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        dataType: 'json',
        data: $('#' + formID).serialize(),
        success: addToCartOk,
        error: addToCartFail,
    });
}

function fetchCart() {
  //alert('called');
  //$('#itemcounter').html('50');
    $.ajax({
        type: 'GET',
        url: '/cart.js',
        dataType: 'json',
        success: function(cart) {
            onCartUpdate(cart);
            if (cart.item_count === 0) {
                cartDrawerContent.innerHTML = 'Your cart is empty!';
                $('.ajax-cart-drawer__subtotal span').html('');  
              //alert(cart.item_count);
               $('#itemcounter').html(cart.item_count);
              cartCounter.innerHTML = cart.item_count;
                checkoutButton.classList.add('is-hidden');
            } else {
                cartCounter.innerHTML = cart.item_count;
                renderCart(cart);
                checkoutButton.classList.remove('is-hidden');
                $('#itemcounter').html = cart.item_count;
            }

        },
    });
}

function changeItem(line, callback) {
    const quantity = 0;
    $.ajax({
        type: 'POST',
        url: '/cart/change.js',
        data: 'quantity=' + quantity + '&line=' + line,
        dataType: 'json',
        success: function(cart) {
            if ((typeof callback) === 'function') {
                callback(cart);
            } else {
                onCartUpdate(cart);
                fetchCart();
                removeProductFromCart();
            }
        },
    });
}
function changeItemcustom(line, quantity) {    
    $.ajax({
        type: 'POST',
        url: '/cart/change.js',
        data: 'quantity=' + quantity + '&id=' + line,
        dataType: 'json',
        success: function(cart) {                            
        fetchCart();                
        },
    });
}

function onCartUpdate(cart) {
    console.log('items in the cart?', cart.item_count);
}

function addToCartOk(product) {
    cartModalContent.innerHTML = product.title + ' was added to the cart!';
    cartCounter.innerHTML = Number(cartCounter.innerHTML) + 1;
    //openAddModal();
    fetchCart();
    openCartDrawer(); 
    openCartOverlay();
}

function removeProductFromCart() {
    cartCounter.innerHTML = Number(cartCounter.innerHTML) - 1;
}

function addToCartFail() {
    cartModalContent.innerHTML = 'The product you are trying to add is out of stock.';
    openAddModal();
    openCartOverlay();
}

function renderCart(cart) {
    clearCartDrawer();   
    cart.items.forEach(function(item, index) {
        const productTitle = '<div class="ajax-cart-item__title">' + item.title + '</div>';
        const productImage = '<div class="ajax-cart-item__image"><img class="ajax-cart-item__image" src="' + item.image + '" ></div>';
        const productPrice = '<div class="ajax-cart-item__price">' + Shopify.formatMoney(item.line_price, "Rs. {{amount}}") + '</div>';
        const productQuantity = '<div class="ajax-cart-item__quantity">' + item.quantity + '</div>';
        const productRemove = '<div class="ajax-cart-item__remove ' + defaults.removeFromCartNoDot + '"></div>';
      	const mainconpro = '<div class="ajax-cart-item__conent">'+productTitle+'<div class="ajax-innerwrap"><div class="ajax-cart-item_priceRemove">'+productPrice+'<div class="ajax-cart-item__remove" data-line="' + Number(index + 1) + '"><span class="remove-text js-ajax-remove-from-cart">Remove</span> <span class="remove-icon"></span></div></div><div class="ajax-cart-item__quantity" data-line="' + item.id + '"><span class="ajax-cart-item__minus-quantity" data-field="quantity[]">-</span><input type="text" class="ajax-cart-item__input-quantity" value="'+item.quantity+'" min="1" pattern="[0-9]*" name="qauntity[]"><span class="ajax-cart-item__add-quantity" data-field="quantity[]">+</span></div></div></div>';
        const concatProductInfo = '<div class="ajax-cart-item__single" data-line="' + Number(index + 1) + '">' + productImage + mainconpro + '</div>';		
      $('.ajax-cart-drawer__subtotal span').html(Shopify.formatMoney(cart.total_price, "Rs. {{amount}}"));      
        cartDrawerContent.innerHTML = cartDrawerContent.innerHTML + concatProductInfo;      
       
    });
    $('#itemcounter').html(cart.item_count);
    removeFromCart = document.querySelectorAll(defaults.removeFromCart);
    for (let i = 0; i < removeFromCart.length; i++) {
        removeFromCart[i].addEventListener('click', function() {
            const line = this.parentNode.getAttribute('data-line');
            console.log(line);
            changeItem(line);
        });
    }
  

}

function openCartDrawer() {
  //alert('open');
    cartDrawer.classList.add('is-open');
}
function openCartPopup() {
  //alert('open');
    cartPopup.classList.add('is-open');
}

function closeCartDrawer() {
    cartDrawer.classList.remove('is-open');
}
function closeCartPopup() {
    cartPopup.classList.remove('is-open');
}
function clearCartDrawer() {
    cartDrawerContent.innerHTML = '';
}

function openAddModal() {
    cartModal.classList.add('is-open');
}

function closeAddModal() {
    cartModal.classList.remove('is-open');
}

function openCartOverlay() {
    /*cartOverlay.classList.add('is-open');
    htmlSelector.classList.add('is-locked');*/
}

function closeCartOverlay() {
    cartOverlay.classList.remove('is-open');
    htmlSelector.classList.remove('is-locked');
}

cartModalClose.addEventListener('click', function() {
    closeAddModal();
    closeCartOverlay();
});

cartDrawerClose.addEventListener('click', function() {
    closeCartDrawer();
    closeCartOverlay();
});
// cart is empty stanje
cartOverlay.addEventListener('click', function() {
    closeAddModal();
    closeCartDrawer();
    closeCartOverlay();
});
cartDrawerTrigger.addEventListener('click', function(event) {
    event.preventDefault();
  //alert('test');
    fetchCart();
    openCartDrawer();
    openCartOverlay();
});
cartDrawerTrigger1.addEventListener('click', function(event) {
    event.preventDefault();
    fetchCart();
    openCartDrawer();
    openCartOverlay();
});
document.addEventListener('DOMContentLoaded', function() {
    fetchCart();
});
